import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { contractorsActions } from "../../../../../_store/contractors.slice";
import { ContractorRatePlanForm } from "./ContractorRatePlanForm";
import { stringToDateForm } from "../../../../../domain/Configuration";
import { RATE_PLAN_TYPE } from "../../../../../domain/RatePlanType";

export function CreateContractorRatePlan({ ratePlanId, contractorId, contractorTypes, intermediaries, addresses, ratePlan, setShowOffCanvas, isClone, isUpdate }) {
  const dispatch = useDispatch();
  const { contractorWastes } = useSelector((x) => x.contractors);
  const intermediariesDictionary = intermediaries
    ? Object.fromEntries(intermediaries?.map((x) => [x.intermediaryId, x.name]))
    : [];
  const addressesDictionary = addresses
    ? Object.fromEntries(addresses?.map((x) => [x.id, x.name]))
    : [];
  const usedWastesDictionary = addresses
    ? Object.fromEntries(addresses?.map((x) => [x.id, x.usedWastes]))
    : [];
  const purchaseServicesDictionary = addresses
    ? Object.fromEntries(addresses?.map((x) => [x.id, x.purchaseServices ?? []]))
    : [];
  const saleServicesDictionary = addresses
    ? Object.fromEntries(addresses?.map((x) => [x.id, x.saleServices ?? []]))
    : [];
  useEffect(() => {
    if (!contractorId || ratePlanId) {
      return;
    }

    const getWastes = async() => {
      await dispatch(contractorsActions.getWastes({ id: contractorId }));
    };

    getWastes();
  }, [contractorId]);
  const isSender = contractorTypes.includes("Sender");
  const isReceiver = contractorTypes.includes("Receiver");
  const isTypeEditable = isSender && isReceiver && !isClone;
  const dateFromForClone = isClone && ratePlan?.dateTo ? new Date(ratePlan.dateTo) : null;
  dateFromForClone?.setDate(new Date(ratePlan.dateTo).getDate() + 1)
  const type = isSender ? "Purchase" : isReceiver ? "Sale" : undefined;
  const purchaseContractorServices = groupByServiceForContractor(purchaseServicesDictionary);
  const saleContractorServices = groupByServiceForContractor(saleServicesDictionary);
  console.log(type)
  const defaultValues = {
    contractorTypes,
    isTypeEditable,
    type: !isTypeEditable ? type : undefined,
    isIntermediaryPricing: !!ratePlan?.intermediaryId,
    ratePlanId,
    ...ratePlan,
    dateFrom: ratePlan?.dateFrom ?
      !isClone || !dateFromForClone ? stringToDateForm(ratePlan.dateFrom) : stringToDateForm(dateFromForClone)
      : null,
    dateTo: ratePlan?.dateTo && !isClone ? stringToDateForm(ratePlan.dateTo) : null,
    remarks: ratePlan?.remarks,
    wastes: !ratePlanId && !isClone ?
      !contractorWastes?.loading && groupByWasteKindForContractor(contractorWastes) :
      ratePlan?.wastes.filter(x => x.isUsed === true).map(x => ({
        ...x,
        wasteKindName: x.wasteKind?.name,
        price: parseFloat(x.price),
        priceBaled: x.wasteAdvancedPricing?.["Baled"],
        priceLoose: x.wasteAdvancedPricing?.["Loose"]
      })),
    // services: ratePlan?.services.map(x => ({ ...x, price: x.price?.toFixed(2) })),
    purchaseContractorServices: purchaseContractorServices,
    saleContractorServices: saleContractorServices,
    services: !ratePlanId && !isClone ?
      !type ? [] : RATE_PLAN_TYPE.PURCHASE ? purchaseContractorServices : saleContractorServices :
      ratePlan?.services.filter(x => x.isUsed === true).map(x => ({
      ...x,
      price: x.price?.toFixed(2),
      priceTon: x.serviceAdvancedPricing?.["Ton"],
      priceUnit: x.serviceAdvancedPricing?.["Unit"],
      priceRunningMeter: x.serviceAdvancedPricing?.["RunningMeter"],
      wasteAdvancedPricing: x.serviceWastesAdvancedPricing?.map(p => ({
        wasteKey: p.wasteKindId ?? p.wasteId,
        wasteId: p.wasteId,
        wasteKindId: p.wasteKindId,
        displayDescription: p.waste?.displayDescription,
        wasteKindName: p.waste?.kinds?.find(k => k.wasteKindId === p.wasteKindId)?.name,
        price: p.pricing?.["General"],
        priceTon: p.pricing?.["Ton"],
        priceUnit: p.pricing?.["Unit"],
        priceRunningMeter: p.pricing?.["RunningMeter"]
      }))
    })),
    intermediaries: intermediariesDictionary,
    addressesDictionary: addressesDictionary,
    addresses: addressesDictionary,
    addressesList: addresses,
    usedWastes: usedWastesDictionary,
    purchaseServices: purchaseServicesDictionary,
    saleServices: saleServicesDictionary,
    isClone,
    isUpdate,
    originalRatePlanId: isClone ? ratePlan?.originalRatePlanId ?? ratePlan?.id : null,
  };

  // if (!contractorId || !defaultValues.wastes || defaultValues.wastes?.length === 0 || defaultValues.wastes?.loading) {
  //   return <p>Aby stworzyć cennik, należy najpierw zdefiniować towary w załadunku / kontenerach</p>
  // }

  return <ContractorRatePlanForm contractorId={contractorId} defaultValues={defaultValues} setShowOffCanvas={setShowOffCanvas}/>;
}

const groupByWasteKindForContractor = (data) => {
  const results = [];
  data?.forEach(entry => {
    const waste = entry;
    entry.kinds?.forEach(x => {
      results.push({
        wasteKind: x,
        wasteKindName: x.name,
        waste: waste
      });
    });

    if(entry.kinds?.length === 0) {
      results.push({
        wasteKind: null,
        wasteKindName: null,
        waste: waste
      });
    }
  });

  return results;
};

const groupByServiceForContractor = (usedServicesDictionary) => {
  const usedServices = {};
  console.log(usedServicesDictionary)
  const services = Object.entries(usedServicesDictionary)?.map(([_, services]) => services).flat();
  services?.forEach(service => {
    if (!usedServices[service.serviceId]) {
      usedServices[service.serviceId] = service;
    }
  });
  return Object.entries(usedServices).map(([serviceId, service]) => ({ serviceId, service }));
};